var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('header-page',[_c('span',{staticClass:"text-dark fw-bold-700 size14"},[_vm._v("Piutang")])]),_c('keep-alive',[_c(_vm.comp,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }